export function resolveWorkspaceSelection(memberships = [], activeTenantId = null) {
  if (!memberships.length) return { chosen: null, persistedActiveTenantId: null };

  const preferred = memberships.find((membership) => membership.tenant_id === activeTenantId) || null;
  return {
    // El fallback mantiene navegable la interfaz, pero NO se presenta como una selección durable.
    // Las Edge Functions siguen fallando cerrado hasta que set_active_tenant() lo persista.
    chosen: preferred || memberships[0],
    persistedActiveTenantId: preferred?.tenant_id || null,
  };
}
